import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/admin.css";

const AddProduct = () => {
    const navigate = useNavigate();
    const backendUrl = process.env.REACT_APP_BACKEND_URI;

    const [title, setTitle] = useState("");
    const [images, setImages] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [isLatest, setIsLatest] = useState(false);

    // ✅ RENAMED: content sections
    const [contentSections, setContentSections] = useState([
        {
            title: "",
            sub_title: "",
            contents: [""],
        },
    ]);

    useEffect(() => {
        const token = localStorage.getItem("adminToken");
        if (!token) navigate("/");
    }, [navigate]);

    const handleImages = (e) => {
        const files = Array.from(e.target.files);
        setImages(files);
        setPreviews(files.map((file) => URL.createObjectURL(file)));
    };

    /* ---------------- CONTENT SECTIONS ---------------- */

    const addSection = () => {
        setContentSections([
            ...contentSections,
            { title: "", sub_title: "", contents: [""] },
        ]);
    };

    const removeSection = (sectionIndex) => {
        setContentSections(
            contentSections.filter((_, i) => i !== sectionIndex)
        );
    };

    const updateField = (sectionIndex, field, value) => {
        const updated = [...contentSections];
        updated[sectionIndex][field] = value;
        setContentSections(updated);
    };

    const addContent = (sectionIndex) => {
        const updated = [...contentSections];
        updated[sectionIndex].contents.push("");
        setContentSections(updated);
    };

    const removeContent = (sectionIndex, contentIndex) => {
        const updated = [...contentSections];
        updated[sectionIndex].contents = updated[
            sectionIndex
        ].contents.filter((_, i) => i !== contentIndex);
        setContentSections(updated);
    };

    const updateContent = (sectionIndex, contentIndex, value) => {
        const updated = [...contentSections];
        updated[sectionIndex].contents[contentIndex] = value;
        setContentSections(updated);
    };

    /* ---------------- SUBMIT ---------------- */

    const submit = async (e) => {
        e.preventDefault();

        if (isLatest) {
            for (const section of contentSections) {
                if (!section.title.trim()) {
                    alert("Section title is required");
                    return;
                }
                if (!section.sub_title.trim()) {
                    alert("Section sub title is required");
                    return;
                }
                if (section.contents.some((c) => !c.trim())) {
                    alert("All content fields are required");
                    return;
                }
            }
        }

        const fd = new FormData();
        fd.append("title", title);
        fd.append("is_latest_product", isLatest);
        fd.append(
            "content_sections",
            JSON.stringify(contentSections)
        );
        images.forEach((img) => fd.append("images", img));

        const res = await fetch(`${backendUrl}/products`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
            },
            body: fd,
        });

        if (res.ok) {
            alert("Product added successfully");
            setTitle("");
            setImages([]);
            setPreviews([]);
            setIsLatest(false);
            setContentSections([
                { title: "", sub_title: "", contents: [""] },
            ]);
        } else {
            alert("Failed to add product");
        }
    };

    return (
        <div className="admin-card">
            <h2>Add Product</h2>

            <form onSubmit={submit} className="admin-form">
                <label>Product Title</label>
                <input
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />

                <label className="checkbox-row">
                    <input
                        type="checkbox"
                        checked={isLatest}
                        onChange={(e) => setIsLatest(e.target.checked)}
                    />
                    <span>Latest Product</span>
                </label>

                {isLatest && (
                    <>
                        <label>Content Sections</label>

                        {contentSections.map((section, si) => (
                            <div key={si} style={{ marginBottom: "18px" }}>
                                <input
                                    placeholder="Section Title"
                                    value={section.title}
                                    onChange={(e) =>
                                        updateField(
                                            si,
                                            "title",
                                            e.target.value
                                        )
                                    }
                                    required
                                />

                                <input
                                    placeholder="Section Sub Title"
                                    style={{ marginTop: "6px" }}
                                    value={section.sub_title}
                                    onChange={(e) =>
                                        updateField(
                                            si,
                                            "sub_title",
                                            e.target.value
                                        )
                                    }
                                    required
                                />

                                {section.contents.map((c, ci) => (
                                    <div
                                        key={ci}
                                        style={{
                                            display: "flex",
                                            gap: "10px",
                                            marginTop: "8px",
                                        }}
                                    >
                                        <input
                                            placeholder="Content"
                                            value={c}
                                            onChange={(e) =>
                                                updateContent(
                                                    si,
                                                    ci,
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                        {ci !== 0 && (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    removeContent(si, ci)
                                                }
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                ))}

                                <button
                                    type="button"
                                    onClick={() => addContent(si)}
                                >
                                    + Add Content
                                </button>

                                {si !== 0 && (
                                    <button
                                        type="button"
                                        onClick={() =>
                                            removeSection(si)
                                        }
                                        style={{ marginLeft: "10px" }}
                                    >
                                        Delete Section
                                    </button>
                                )}
                            </div>
                        ))}

                        <button type="button" onClick={addSection}>
                            + Add Section
                        </button>
                    </>
                )}

                <label>Product Images</label>
                <input type="file" multiple onChange={handleImages} />

                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {previews.map((src, i) => (
                        <img key={i} src={src} alt="" width={80} />
                    ))}
                </div>

                <button type="submit" className="submit-btn">
                    Add Product
                </button>
            </form>
        </div>
    );
};

export default AddProduct;
